import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// Matches BackendService.Responses.Response
export interface ApiResponse<T> {
  isSuccess: boolean;
  message: string;
  data: T;
}

// Matches BackendService.Models.DTO.TrainingFileDTO
export interface TrainingFileDTO {
  id: number | null;
  fileName: string | null;
}

// Matches BackendService.Models.MainModels.AssignedTraining
export interface AssignedTraining {
  id: number;
  trainingFileId: number;
  trainingFileName: string | null;
  employer: string | null;
  program: string | null;
  clientId: string | null;
  clientName: string | null;
  job: string | null;
  startDate: string | null;
  endDate: string | null;
  isDeleted: boolean;
  createdAt: string;
}

// Shape returned by GetAssignedTrainings
export interface AssignedTrainingsPage {
  assignedTrainings: AssignedTraining[];
  totalCount: number;
}

// Matches BackendService.Models.DTO.AssignTrainingRequestDTO
export interface CreateAssignmentPayload {
  trainingFileId: number;
  trainingFileName?: string;
  employers?: string[];
  programs?: string[];
  clientIds?: number[];
  clientNames?: string[];
  jobs?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class AssignTrainingService {
  constructor(private http: HttpClient) {}

  getTrainingList(): Observable<ApiResponse<TrainingFileDTO[]>> {
    return this.http.get<ApiResponse<TrainingFileDTO[]>>(`${environment.apiConfig.uri}/admin/AssignTraining/GetTrainingList`);
  }

  getEmployers(): Observable<ApiResponse<string[]>> {
    return this.http.get<ApiResponse<string[]>>(`${environment.apiConfig.uri}/admin/AssignTraining/GetEmployers`);
  }

  getPrograms(): Observable<ApiResponse<string[]>> {
    return this.http.get<ApiResponse<string[]>>(`${environment.apiConfig.uri}/admin/AssignTraining/GetPrograms`);
  }

  getClients(): Observable<ApiResponse<string[]>> {
    return this.http.get<ApiResponse<string[]>>(`${environment.apiConfig.uri}/admin/GetTimeSheetProjects`);
  }

  getJobs(): Observable<ApiResponse<string[]>> {
    return this.http.get<ApiResponse<string[]>>(`${environment.apiConfig.uri}/admin/AssignTraining/GetJobs`);
  }

  getAssignedTrainings(pageNumber: number, pageSize: number): Observable<ApiResponse<AssignedTrainingsPage>> {
    return this.http.get<ApiResponse<AssignedTrainingsPage>>(`${environment.apiConfig.uri}/admin/AssignTraining/GetAssignedTrainings`, {
      params: { pageNumber: pageNumber.toString(), pageSize: pageSize.toString() }
    });
  }

  createAssignment(payload: CreateAssignmentPayload): Observable<ApiResponse<AssignedTraining>> {
    return this.http.post<ApiResponse<AssignedTraining>>(`${environment.apiConfig.uri}/admin/AssignTraining/Create`, payload);
  }

  updateAssignTraining(id: number, startDate: string | null, endDate: string | null): Observable<ApiResponse<AssignedTraining>> {
    return this.http.patch<ApiResponse<AssignedTraining>>(
      `${environment.apiConfig.uri}/admin/AssignTraining/UpdateAssignTraining/${id}`,
      null,
      { params: { ...(startDate && { startDate }), ...(endDate && { endDate }) } }
    );
  }

  deleteAssignTraining(id: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${environment.apiConfig.uri}/admin/AssignTraining/DeleteAssignTraining/${id}`);
  }
}
